module.exports = __webpack_public_path__ + "static/img/ggzy01.5777daf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ggzy01.png
// module id = BUkb
// module chunks = 1